import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { ElementVisibleMixin } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/element-visible.js';
import { gridBreakpoints } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import styles from './image.scss.js';
/**
 * @returns Image component.
 *
 * @csspart img - the image elements
 */
export class Image extends ElementVisibleMixin(CipublicElement) {
    constructor() {
        super(...arguments);
        this.sources = [];
        /**
         * Optional, loads image eager or lazy.
         */
        this.loading = 'eager';
        /**
         * Boolean value to determine image Drop Effect. Defaults to `false`.
         */
        this.dropShadow = false;
        /**
         * Defaults to true, can be removed and image won't be responsive
         */
        this.responsive = true;
        /**
         * Boolean value to determine image visibility. Defaults to `false`.
         */
        this.showImage = false;
        /**
         * The position of the image
         */
        this.imagePosition = 'initial';
    }
    static get styles() {
        return [styles];
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('intersection') || changedProperties.has('loading')) {
            if (this.loading === 'eager' || (this.loading === 'lazy' && this.intersection.isVisible)) {
                this.showImage = true;
            }
        }
        super.updated(changedProperties);
    }
    render() {
        const classes = { resize: true, imageShadow: this.dropShadow };
        const types = {
            avif: 'image/avif',
            webp: 'image/webp',
            gif: 'image/gif',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            svg: 'image/svg+xml',
            bmp: 'image/bmp',
        };
        const sources = (this.sources || []).reduce((accumulator, current) => {
            Object.keys(current).forEach((breakpoint) => {
                const src = current[breakpoint];
                const ext = src.split('.').pop() || '';
                const type = types[ext];
                if (type) {
                    if (breakpoint.toString() === 'default') {
                        accumulator.push([null, type, src]);
                    }
                    else {
                        accumulator.push([`(min-width: ${gridBreakpoints[breakpoint].toString()}px)`, type, src]);
                    }
                }
            });
            accumulator.sort().reverse();
            return accumulator;
        }, []);
        return this.showImage
            ? html `<picture>${sources.map(([media, type, uri]) => html `<source media="${ifDefined(media)}" type="${type}" srcset="${uri}">`)} <img class="${classMap(classes)}" src="${this.src}" alt="${ifDefined(this.alt)}" loading="${this.loading}" width="${ifDefined(this.width)}" height="${ifDefined(this.height)}" style="object-position:${this.imagePosition}"></picture>`
            : html `<div class="placeholder-image" width="${ifDefined(this.width)}" height="${ifDefined(this.height)}"></div>`;
    }
}
__decorate([
    property({ reflect: true })
], Image.prototype, "alt", void 0);
__decorate([
    property({ reflect: true })
], Image.prototype, "src", void 0);
__decorate([
    property({ reflect: true, type: Array, attribute: 'sources' })
], Image.prototype, "sources", void 0);
__decorate([
    property({ reflect: true })
], Image.prototype, "loading", void 0);
__decorate([
    property({ reflect: true, type: Number })
], Image.prototype, "width", void 0);
__decorate([
    property({ reflect: true, type: Number })
], Image.prototype, "height", void 0);
__decorate([
    property({ type: Boolean, attribute: 'dropshadow' })
], Image.prototype, "dropShadow", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], Image.prototype, "responsive", void 0);
__decorate([
    state()
], Image.prototype, "showImage", void 0);
__decorate([
    property()
], Image.prototype, "imagePosition", void 0);
//# sourceMappingURL=image.js.map